import React, { useState } from "react";
import { alpha, IconButton, Stack } from "@mui/material";
import { blue, orange } from "@mui/material/colors";
import { LocationAdd, Location } from "iconsax-react";
import { useNavigate } from "react-router-dom";
import { ROUTES_CONSTANTS } from "../../../constants/routesConstants";
import GuidesMapDialog from '../GuidesMapDialog';
import { usePermissions } from "../../../hooks/permissions/usePermissions";

export default function GuidesTableActions({ guide, fetchGuides, fetchUnassingnedGuides }) {
  const [openDialog, setOpenDialog] = useState(null);
  const navigate = useNavigate();

  const { hasAllPermissions } = usePermissions();

  const handleDialogOpen = (dialogName) => {
    setOpenDialog(dialogName);
  };

  const handleDialogClose = () => {
    setOpenDialog(null);
  };

  const handleTrackingClick = (event) => {
    event.stopPropagation();
    if (guide.tracking_code) {
      navigate(`${ROUTES_CONSTANTS.TRACKING}?code=${guide.tracking_code}`);
    }
  };

  return (
    <Stack
      direction="row"
      spacing={0.1}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        gap: "4px",
      }}
    >
      {/* <GuidesQRImageDialog
        open={openDialog === "QRImage"}
        onClose={() => {
          handleDialogClose();
        }}
        urlImage={guide.s3_qrcode}
      /> */}
      <GuidesMapDialog
        open={openDialog === "Map"}
        fetchGuides={fetchGuides}
        fetchUnassingnedGuides={fetchUnassingnedGuides}
        guide={guide}
        onClose={() => {
          handleDialogClose();
        }}
      />
      {/* <GuidesQRImageDialog
        open={openDialog === "QRImage"}
        onClose={() => {
          handleDialogClose();
        }}
        urlImage={guide.s3_qrcode} */}
        
      
      {hasAllPermissions(["rte_vw", "up_loc_g", 'rte_pac_vw']) && (<IconButton
        size="small"
        color="primary"
        aria-label="Location button"
        onClick={() => handleDialogOpen("Map")}
        style={{ color: blue[400], backgroundColor: alpha(blue[500], 0.1) }}
      >
        <LocationAdd fontSize="small" />
      </IconButton>)}

      <IconButton
        size="small"
        color="primary"
        aria-label="rastrear guía"
        onClick={handleTrackingClick}
        style={{ color: orange[600], backgroundColor: alpha(orange[500], 0.1) }}
      >
        <Location fontSize="small" />
      </IconButton>
      {/* <IconButton
        size="small"
        color="primary"
        aria-label="add to shopping cart"
        onClick={() => handleDialogOpen("QRImage")}
        style={{ color: blue[400], backgroundColor: alpha(blue[500], 0.1) }}
      >
        <ScanBarcode fontSize="small" />
      </IconButton> */}
    </Stack>
  );
}
